import { addError } from 'action-creators/ErrorActionCreators';
import { connect } from 'react-redux';

import SequenceOfOperationsPage from 'components/pages/SequenceOfOperationsPage';

const mapStateToProps = (state, _ownProps) => ({
  anySorting: state.ui.ordering.anyOrdering,
  anyUnsaved: Object.values(state.ui.toggling).some(Boolean),
  containerStyling: state.ui.styling.projectTrades,
  isAvailable: state.domain.projectTradeCollection.allDataIds.length === 0,
  isFetching: state.application.pending.projectTradeFetch,
  isReviewing: state.application.isReviewing,
});

const mapDispatchToProps = (dispatch, _ownProps) => ({
  dispatch,
  addError: (errorKey, payload) => dispatch(addError(errorKey, payload)),
});

const AvailableSequenceOfOperationsPage = connect(
  mapStateToProps,
  mapDispatchToProps,
)(SequenceOfOperationsPage);

export default AvailableSequenceOfOperationsPage;
